module.exports = __webpack_public_path__ + "img/TRX.8e110c1c.svg";